<template>
  <div class="vm-btn">
    <div v-if="text" v-html="text"></div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "btn",
  props: {
    text: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="stylus" scoped>
.vm-btn {
  border-radius: px2rem(2);
  background: linear-gradient(90deg, $purple, $purple-deep);
  color: $white;
  padding: 8px 24px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  white-space: nowrap;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  box-sizing: border-box;
  position: relative;

  &:hover {
    background: linear-gradient(90deg, $purple, $purple-deep-more);
  }

  &.circle{
      border-radius:50px;
  }

  &.flex-box{
    display flex;
  }

  &.block{
    display block;
  }

  &.red {
    background: $red;
  }

  &.white-bg {
    background: $white;
  }

  &.bg-none{
    background: transparent;
  }

  &.w100 {
    width: 100%;
    justify-content: center;
  }

  &.look1 {
    background: $black-05;
    color: $black-5;
    font-size: fs2rem(12);
  }

  &.look2 {
    background: $white;
    color: $black-5;
    font-size: fs2rem(14);
    border: 1px solid $black-1;
  }

  &.look3 {
    background: $purple-1;
    color: $purple;

    &:hover {
      background: $purple-2;
    }
    &.border{
      border:1px solid $purple;
    }
  }

  &.look4 {
    background: transparent;
    color: $black-5;

    &:hover {
      color: $black;
    }
  }

  &.look5 {
    background: $white;
    color: $purple;
  }

  &.look6 {
    font-size: fs2rem(12);
  }

  &.look7 {
    background: $blue;
  }

  &.look8 {
    border: 1px solid $purple;
    color: $purple;
    box-sizing: border-box;
  }

  &.look9 {
    color: $white;
    background: $group-2;
    box-sizing: border-box;
  }

  &.look10 {
    color: $white;
    font-size: 12px;
    box-sizing: border-box;
    border-radius: 100px;
  }

  &.look11 {
    // border: 0;
    color: $white;
    box-sizing: border-box;
    background: $forever;

  }
  &.look12 {
    // border: 0;
    color: $black-3;
    box-sizing: border-box;
    background: $white-bg;

  }
  &.look13 {
    color: $black-3;
    box-sizing: border-box;
    background: rgba(0,0,0,.03);
    &:hover{
        background: rgba(0,0,0,.05);
    }
  }

  &.disable {
    cursor: not-allowed;
    background: $black-05;
    color:$black-3;

    &:hover {
      // background: $black-2;
    }
  }

  &.size2 {
    padding: px2rem(8) px2rem(48);
  }

  &.size32 {
    padding: px2rem(8) px2rem(28);
    font-size: 14px;
  }
  &.size38 {
    padding: 12px px2rem(28);
    font-size: 14px;
  }

  &.size40 {
    font-size: 16px;
    padding: px2rem(12) px2rem(60);
  }

  &.size48 {
    font-size: 16px;
    padding: 13px 50px;
  }

  @media (max-width: $width-mobile) {
    &.mq { // media-query
      &.size48 {
        width: 100%;
        justify-content: center;
      }
    }
    &.circle{
      border-radius:20px;
    }
  }
}
</style>
